import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { AltImages, MainImageSlider } from '../../../../Shared/Content/ProductDetail/ProductAltImages/ProductAltImages';
import { Title } from '../../../../Shared/Content/ProductDetail/ProductTitle/ProductTitle';
import { ItemNumber } from '../../../../Shared/Content/ProductDetail/ProductItemNumber/ProductItemNumber';
import ProductReviewStars from '../../../../Shared/Content/ProductDetail/ProductReviewStars/ProductReviewStars';
import { Price } from '../../../../../UI/Price/Price';
import { ProductRecs } from '../../../../../UI/ProductRecs/ProductRecs';
import { Quantity } from '../../../../Shared/Content/ProductDetail/ProductQuantity/ProductQuantity';
import { ProductDescription } from '../../../../Shared/Content/ProductDetail/ProductDescription/ProductDescription';
import { BrandDescription } from '../../../../Shared/Content/ProductDetail/BrandDescription/BrandDescription';
import { ProductShipping } from '../../../../Shared/Content/ProductDetail/ProductShipping/ProductShipping';
import { ProductExtraVerbiage } from '../../../../Shared/Content/ProductDetail/ProductExtraVerbiage/ProductExtraVerbiage';
import ProductOurStylistSuggests from '../../../../Shared/Content/ProductDetail/ProductOurStylistSuggests/ProductOurStylistSuggests';
import ProductSocialMedia from '../../../../Shared/Content/ProductDetail/ProductSocialMedia/ProductSocialMedia';
import ProductDetailForm from '../../../../Shared/Content/ProductDetail/ProductDetailForm/ProductDetailForm';
import ProductDetailSwatches from '../../../../Shared/Content/ProductDetail/ProductDetailSwatches/ProductDetailSwatches';
import ProductDetailAttribute from '../../../../Shared/Content/ProductDetail/ProductDetailAttribute/ProductDetailAttribute';
import ProductDetailReviews from '../../../../Shared/Content/ProductDetail/ProductDetailReviews/ProductDetailReviews';
import ProductLeftRightEspot from '../../../../Shared/Content/ProductDetail/ProductLeftRightEspot/ProductLeftRightEspot';
import { ProductCollection } from '../../../../Shared/Content/ProductDetail/ProductCollection/ProductCollection';
import { WishListMessage } from '../../../../Shared/Content/ProductDetail/WishListMessage/WishListMessage';
import { AddToBrandFavorites } from '../../../../Shared/Content/ProductDetail/AddToBrandFavorites/AddToBrandFavorites';
import AfterPayMessaging from '../../../../Shared/Content/ProductDetail/AfterPayMessaging/AfterPayMessaging';
import { PhotoSwipeZoom, MainImagePhotoSwipeZoom } from '../PhotoSwipeZoom/PhotoSwipeZoom';
import ProductRecommendations from '../../Layouts/Widgets/ProductRecommendations/ProductRecommendations';
import InvalidCombo from '../../../../Shared/Content/ProductDetail/InvalidCombo/InvalidCombo';
import ProductSubscription from '../../../../Shared/Content/ProductDetail/ProductSubscription/ProductSubscription';
import AddToBagButton from '../../../../Shared/Content/ProductDetail/AddToBagButton/AddToBagButton';
import ProductDetailQuestionAnswers from '../../../../Shared/Content/ProductDetail/ProductDetailQuestionAnswers/ProductDetailQuestionAnswers';
import ProductStylitics from '../../../../Shared/Content/ProductDetail/ProductStylitics';
import SetInnerHTML from '../../../../../UI/SetInnerHTML/SetInnerHTML';
import ProductMisc from '../../../../Shared/Content/ProductDetail/ProductMisc/ProductMisc';
import WcPowerPage from '../../../../Shared/Content/ProductDetail/ProductDisplay/WcPowerPage';
import debounce from 'lodash/debounce';
import FindInStore from '../../../../Shared/Content/ProductDetail/FindInStore/FindInStore';
import { ShowImboxModal } from '../../../../Shared/Content/Imbox/ShowImboxModal';

export class ProductDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceWidth: 770,
      isOpen: false,
      needSaleRecs: false,
      options: {
        showHideOpacity: true,
        allowPanToNext: true,
        maxSpreadZoom: 3,
        closeOnVerticalDrag: true,
        focus: true,
      },
    };

    this.zoomIndex = 0;

    this.zoomIndex = 0;
  }

  componentDidMount() {
    if (this.props.passedAppFunctions.siteFormat == 'desktop') {
      this.setState({ deviceWidth: window.outerWidth });
      this.desktopResizeHandler = _.debounce(() => this.setState({ deviceWidth: window.outerWidth }), 300);
      window.addEventListener('resize', this.desktopResizeHandler);
    } else {
      // Using window.innerWidth for Tablet. IOS 10 was returning window.outerWidth = 0
      this.setState({ deviceWidth: window.innerWidth });
      this.tabletResizeHandler = _.debounce(() => this.setState({ deviceWidth: window.innerWidth }), 300);
      window.addEventListener('resize', this.tabletResizeHandler);
    }
  }

  componentWillUnmount() {
    if (this.desktopResizeHandler) {
      window.removeEventListener('resize', this.desktopResizeHandler);
      this.desktopResizeHandler.cancel();
    }
    if (this.tabletResizeHandler) {
      // Using window.innerWidth for Tablet. IOS 10 was returning window.outerWidth = 0
      window.removeEventListener('resize', this.tabletResizeHandler);
      this.tabletResizeHandler.cancel();
    }
  }

  openPhotoSwipe = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: true,
      options: {
        index: this.zoomIndex,
        closeOnScroll: false,
      },
    });
  };

  handleClose = () => {
    let index = this.state.options.index;
    let parentThis = this;
    let altWrapper = document.getElementById('product-alt-wrapper');
    if (parentThis.props.contentData.altImages === undefined) {
    } else {
      // if the alt image isn't lazyloaded - click it.
      // if the swipe image's corresponding alt container is lazyloaded, the mutation observer will take care of the click.
      let altImageToUse = parentThis.props.contentData.altImages[index];
      let imageName = altImageToUse.imageName;
      if (document.getElementById(imageName) === null) {
        if (altWrapper !== null) {
          var altToClick = altWrapper.querySelector(`[data-index='${index}']`);
          altToClick.click();
        }
        var observer = new MutationObserver(function (mutations, slickObserver) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
              var altButtonToClick = mutation.target.firstElementChild.firstElementChild;
              if (altButtonToClick !== null) {
                altButtonToClick.click();
                slickObserver.disconnect();
              }
            }
          });
        });
        var slideToWatch = altWrapper.querySelector(`[data-index='${index}']`);
        var observerOptions = { childList: true, subtree: true };
        observer.observe(slideToWatch, observerOptions);
      } else {
        document.getElementById(imageName).click();
      }
    }
    this.setState({ isOpen: false });
  };

  liveChatOnClickBeauty() {
    window.openChatButtonClick();
  }

  updateZoomIndex = (i) => {
    this.zoomIndex = i;
  };

  openPhotoSwipeMain = (e) => {
    let dataKey = parseInt(e.target.getAttribute('data-key'));
    this.setState({
      isOpen: true,
      options: {
        index: dataKey,
        closeOnScroll: false,
      },
    });
  };

  render() {
    var settings = {
      containsAlts: this.props.contentData.altImages ? true : false,
    };
    var preOrder = this.props.contentData.preOrder,
      previewItem =
        preOrder !== undefined &&
        (preOrder.preOrderMessage !== undefined || preOrder.previewEndDateMessage !== undefined)
          ? true
          : false;
    let isInternetExclusive = this.props?.contentData?.auxVerbiage1?.includes('Internet Exclusive') || false;

    return (
      <section id='ProductDisplay' className='productDisplay'>
        <div
          className={`row m-0 d-flex justify-content-between ${this.props.passedFunctions.parentState.imageClickedOn ? 'hidden' : ''}`}
        >
          {this.props.passedAppFunctions.siteFormat != 'tablet' ? (
            <div className={`${settings.containsAlts ? 'col-md-1 col-lg-1' : 'col-sm-0'} p-0 altCol`}>
              <AltImages
                currentAttributeState={this.props.currentAttributeState}
                contentData={this.props.contentData}
                passedFunctions={this.props.passedFunctions}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                passedAppFunctions={this.props.passedAppFunctions}
                altClicked={this.props.altClicked}
              />
            </div>
          ) : (
            ''
          )}
          {(this.props.passedAppFunctions.siteFormat == 'desktop' || !this.props.contentData.altImages) && (
            <PhotoSwipeZoom
              isOpen={this.state.isOpen}
              options={this.state.options}
              passedFunctions={this.props.passedFunctions}
              handleClose={this.handleClose}
              contentData={this.props.contentData}
              selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
              updateZoomIndex={this.updateZoomIndex}
            />
          )}
          <div
            className={`col-sm-6 ${
              settings.containsAlts || (!settings.containsAlts && this.props.passedAppFunctions.siteFormat == 'tablet')
                ? 'col-md-7 col-lg-5'
                : 'col-md-6 col-lg-5'
            } col-xl-5 mainImageCol`}
          >
            {(this.props.passedAppFunctions.siteFormat == 'desktop' || !this.props.contentData.altImages) && (
              <>
                <MainImage
                  passedFunctions={this.props.passedFunctions}
                  passedAppFunctions={this.props.passedAppFunctions}
                  contentData={this.props.contentData}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  openPhotoSwipe={this.openPhotoSwipe}
                  swatchGroups={this.props.passedFunctions.parentState.swatchGroups}
                />
                <div className='dds-stylitics-jumplink-wrapper'>
                  <a href='#dds-stylitics-widget-title' className='dds-stylitics-jumplink' id='stylitics-jumplink'>
                    How To Style
                  </a>
                </div>
              </>
            )}
            {this.props.passedAppFunctions.siteFormat != 'desktop' && this.props.contentData.altImages && (
              <>
                <MainImagePhotoSwipeZoom
                  isOpen={this.state.isOpen}
                  options={this.state.options}
                  passedFunctions={this.props.passedFunctions}
                  handleClose={this.handleClose}
                  contentData={this.props.contentData}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  updateZoomIndex={this.updateZoomIndex}
                />
                <MainImageSlider
                  contentData={this.props.contentData}
                  passedFunctions={this.props.passedFunctions}
                  passedAppFunctions={this.props.passedAppFunctions}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  openPhotoSwipeMain={this.openPhotoSwipeMain}
                  altClicked={this.props.altClicked}
                />
                <div className='dds-stylitics-jumplink-wrapper'>
                  <a href='#dds-stylitics-widget-title' className='dds-stylitics-jumplink' id='stylitics-jumplink'>
                    How To Style
                  </a>
                </div>
              </>
            )}
            {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
              <span className='tapToZoom'>Tap image to zoom</span>
            ) : (
              ''
            )}
            {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
              //Alts displayed below MainImage for tablet.
              <AltImages
                currentAttributeState={this.props.currentAttributeState}
                contentData={this.props.contentData}
                passedFunctions={this.props.passedFunctions}
                vertical={false}
                passedAppFunctions={this.props.passedAppFunctions}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                altClicked={this.props.altClicked}
              />
            ) : (
              ''
            )}
            <ProductOurStylistSuggests
              contentData={this.props.contentData}
              passedAppFunctions={this.props.passedAppFunctions}
              passedFunctions={this.props.passedFunctions}
              selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
            />
            <ProductLeftRightEspot contentData={this.props.contentData} />
            <ProductStylitics
              contentData={this.props.contentData}
              passedFunctions={this.props.passedFunctions}
              passedAppFunctions={this.props.passedAppFunctions}
              selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
            />
          </div>
          <div
            className={`col-sm-6 ${this.props.passedAppFunctions.siteFormat == 'tablet' ? 'col-md-5' : 'col-md-4'} col-lg-4 col-xl-4 shopperActionsColumn`}
          >
            <Title contentData={this.props.contentData} passedAppFunctions={this.props.passedAppFunctions} />
            {this.props.contentData.dept != '0968' && (
              <ProductReviewStars
                passedFunctions={this.props.passedFunctions}
                passedAppFunctions={this.props.passedAppFunctions}
                contentData={this.props.contentData}
              />
            )}
            {this.props.contentData.unavailableMessage == '' ||
            typeof this.props.contentData.unavailableMessage == 'undefined' ? (
              <Price
                pricing={
                  this.props.passedFunctions.parentState.curSelectedAttr
                    ? this.props.passedFunctions.flatSizesPriceObject()
                    : this.props.contentData.pricing
                }
                currentAttributeState={this.props.passedFunctions.parentState.currentAttributeState}
                passedAppFunctions={this.props.passedAppFunctions}
                passedFunctions={this.props.passedFunctions}
                showFreeShipping={this.props.passedFunctions.shouldShowFreeShipping()}
              />
            ) : (
              <div>
                <Link to={`/brand/${this.props.contentData.personalization.urlFormattedBrandName}`}>
                  <button className='btn btn-secondary btn-block m-t-10 m-b-10'>
                    Shop All {this.props.contentData.personalization.brandName}{' '}
                  </button>
                </Link>
                <div id='preorder-alert' className='alert alert-danger' role='alert'>
                  <SetInnerHTML innerHTML={this.props.contentData.unavailableMessage} />
                </div>
              </div>
            )}
            {this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational() ? (
              this.props.contentData.preOrder && this.props.contentData.preOrder.previewEndDateMessage ? (
                ''
              ) : this.props.contentData.unavailableMessage == '' ||
                typeof this.props.contentData.unavailableMessage == 'undefined' ? (
                <ProductDetailForm
                  currentAttributeState={this.props.currentAttributeState}
                  passedFunctions={this.props.passedFunctions}
                  contentData={this.props.contentData}
                  wrapperClass={this.props.wrapperClass}
                >
                  {this.props.contentData.productContainsRegPricedMerch == 'true' &&
                  this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                    ''
                  ) : (
                    <ProductDetailAttribute
                      key={this.props.contentData.productId}
                      passedFunctions={this.props.passedFunctions}
                      passedAppFunctions={this.props.passedAppFunctions}
                      updateAttribute={this.props.passedFunctions.updateAttribute}
                      updateAttrState={this.props.passedFunctions.updateAttrState}
                      currentAttributeState={this.props.currentAttributeState}
                      contentData={this.props.contentData}
                      changeAttributeState={this.props.passedFunctions.changeAttributeState}
                    />
                  )}

                  <div className='col-sm-12 p-0 m-b-15 float-none'>
                    {this.props.contentData.productContainsRegPricedMerch == 'true' && (
                      <div className='form-group'>
                        {this.props.contentData.salePage == 'true' &&
                        this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                          <span className='d-block regularPriceOptionsText'>
                            This item is no longer available in Sale and Clearance.
                          </span>
                        ) : (
                          ''
                        )}
                        <Link
                          to={`/p/${this.props.contentData.productNameForURL}/${this.props.contentData.productId}`}
                          className='regularPriceOptions'
                        >
                          See Regular Price Options
                        </Link>
                      </div>
                    )}

                    {this.props.contentData.productContainsRegPricedMerch == 'true' &&
                    this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                      ''
                    ) : (
                      <Quantity
                        updateQuantity={this.props.passedFunctions.updateQuantity}
                        quantity={this.props.passedFunctions.parentState.quantity}
                        quantityErrored={this.props.passedFunctions.parentState.quantityErrored}
                        contentData={this.props.contentData}
                        passedAppFunctions={this.props.passedAppFunctions}
                        forceQuantity={this.props.passedFunctions.forceQuantity}
                      />
                    )}
                  </div>

                  {this.props.contentData.productContainsRegPricedMerch == 'true' &&
                  this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                    ''
                  ) : (
                    <React.Fragment>
                      {(this.props.contentData.productSubscriptionEligible || 'N') == 'Y' && (
                        <ProductSubscription
                          contentData={this.props.contentData}
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                        />
                      )}
                      <div className='addToBagContainer'>
                        <InvalidCombo
                          currentAttributeState={this.props.currentAttributeState}
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                        />

                        <AddToBagButton
                          contentData={this.props.contentData}
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                          currentAttributeState={this.props.currentAttributeState}
                        />
                      </div>
                      {this.props.contentData.superCat == 'Beauty' ? (
                        <button
                          className='btn btn-secondary btn-block beauty-chat'
                          role='button'
                          type='button'
                          onKeyPress={this.liveChatOnClickBeauty}
                          onClick={this.liveChatOnClickBeauty}
                          manual_cm_sp='video+chat-_-beauty-_-product'
                        >
                          <span className='sr-only'>Opens a simulated dialog</span>
                          Chat with a Beauty Expert
                        </button>
                      ) : (
                        ''
                      )}

                      <WishListMessage
                        passedFunctions={this.props.passedFunctions}
                        passedAppFunctions={this.props.passedAppFunctions}
                      />

                      {!this.props.passedAppFunctions.isInternational() ? (
                        <button
                          className='btn btn-tertiary'
                          role='button'
                          id='add-to-wishlist'
                          type='button'
                          // onClick={this.props.passedFunctions.ajaxAddToWishlist}
                          onClick={this.props.passedFunctions.checkForErrorsWishlist}
                        >
                          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.58 12.44' aria-hidden='true'>
                            <title>heart</title>
                            <g data-name='Layer 2'>
                              <g data-name='Layer 1'>
                                <path
                                  className='cls-1'
                                  d='M7.79,12.44a.54.54,0,0,1-.32-.11L1.66,7.46l0,0A4.78,4.78,0,0,1,0,4.14,4.15,4.15,0,0,1,4.14,0,4.13,4.13,0,0,1,7.82,2.14,4.19,4.19,0,1,1,14.3,7.33l-6.19,5A.5.5,0,0,1,7.79,12.44ZM2.32,6.71,7.8,11.29l5.84-4.71a3.15,3.15,0,0,0-2.21-5.4,3,3,0,0,0-3.08,2.4.51.51,0,0,1-.07.17A.64.64,0,0,1,7.83,4a.5.5,0,0,1-.44-.18,1.3,1.3,0,0,1-.14-.29A3,3,0,0,0,4.14,1,3.15,3.15,0,0,0,1,4.14,3.66,3.66,0,0,0,2.32,6.71Z'
                                />
                              </g>
                            </g>
                          </svg>
                          Add To Wish List
                        </button>
                      ) : (
                        ''
                      )}

                      {!this.props.passedAppFunctions.isInternational() ? (
                        <button
                          className='btn btn-tertiary'
                          role='button'
                          id='add-to-registry'
                          type='button'
                          // onClick={this.props.passedFunctions.ajaxAddToRegistry}
                          onClick={this.props.passedFunctions.checkForErrorsRegistry}
                        >
                          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50.42 49.84' aria-hidden='true'>
                            <title>gift</title>
                            <g data-name='Layer 2'>
                              <g data-name='Layer 1'>
                                <path d='M48,9.79H39.64a5.33,5.33,0,0,0-1-9.43,5.3,5.3,0,0,0-4.09.1c-2.16,1-8,7.3-9.37,8.82C23.8,7.76,18,1.42,15.81.46a5.33,5.33,0,0,0-5.1,9.33H2.45A2.45,2.45,0,0,0,0,12.24v4.39a2.45,2.45,0,0,0,2.45,2.45H3a3.46,3.46,0,0,0-.53,1.84V46.35a3.5,3.5,0,0,0,3.49,3.49H44.41a3.5,3.5,0,0,0,3.49-3.49V20.92a3.46,3.46,0,0,0-.53-1.84H48a2.45,2.45,0,0,0,2.45-2.45V12.24A2.45,2.45,0,0,0,48,9.79ZM35.36,2.3A3.32,3.32,0,0,1,38,8.39c-1.2.53-6.12.76-10.05.81C30.68,6.32,34.16,2.83,35.36,2.3ZM10.61,4A3.33,3.33,0,0,1,15,2.3c1.2.53,4.68,4,7.36,6.89-3.93,0-8.85-.28-10.05-.81h0A3.33,3.33,0,0,1,10.61,4ZM2,16.63V12.24a.43.43,0,0,1,.43-.43H24.2v5.26H2.45A.43.43,0,0,1,2,16.63ZM4.47,46.35V20.92a1.48,1.48,0,0,1,1.48-1.48H24.2V47.82H5.94A1.48,1.48,0,0,1,4.47,46.35Zm41.42,0a1.48,1.48,0,0,1-1.48,1.48H26.22V19.44H44.41a1.48,1.48,0,0,1,1.48,1.48Zm2.52-29.71a.43.43,0,0,1-.43.43H26.22V11.81H48a.43.43,0,0,1,.43.43Z' />
                              </g>
                            </g>
                          </svg>
                          Add To Registry
                        </button>
                      ) : (
                        ''
                      )}

                      <AddToBrandFavorites
                        passedAppFunctions={this.props.passedAppFunctions}
                        contentData={this.props.contentData}
                        passedFunctions={this.props.passedFunctions}
                      />
                    </React.Fragment>
                  )}
                </ProductDetailForm>
              ) : (
                ''
              )
            ) : (
              <div id='error-message' className='alert alert-danger' role='alert'>
                This item is not available for international purchase.
              </div>
            )}
            {this.props.contentData.skus.length > 0 &&
            !isInternetExclusive &&
            this.props.passedAppFunctions.wasParms.allowFindInStore == 'true' ? (
              <FindInStore currentAttributeState={this.props.currentAttributeState} />
            ) : (
              ''
            )}
            <ProductDescription
              open={true}
              previewItem={this.previewItem}
              contentData={this.props.contentData}
              passedAppFunctions={this.props.passedAppFunctions}
            />
            <BrandDescription
              open={false}
              contentData={this.props.contentData}
              passedAppFunctions={this.props.passedAppFunctions}
            />
            <ProductShipping contentData={this.props.contentData} />
            <ProductMisc
              contentData={this.props.contentData}
              passedFunctions={this.props.passedFunctions}
              passedAppFunctions={this.props.passedAppFunctions}
            />
            <ProductSocialMedia
              contentData={this.props.contentData}
              passedFunctions={this.props.passedFunctions}
              siteFormat={this.props.passedAppFunctions.siteFormat}
            />
          </div>
          <div className='col-md-12 col-lg-2 productRecsColumn'>
            <ProductRecs
              zoneName='PDPZ1'
              contentData={this.props.contentData}
              vertical={true}
              passedAppFunctions={this.props.passedAppFunctions}
            />
          </div>
        </div>
        <ProductCollection
          contentData={this.props.contentData}
          selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
          attributeState={this.props.passedFunctions.parentState.attributeState}
          passedAppFunctions={this.props.passedAppFunctions}
          passedFunctions={this.props.passedFunctions}
          slidesToShow={6}
        />
        <div className='m-t-30 recentlyViewedContainer'>
          <ProductRecommendations
            widgetData={{
              zone: 'RecentlyViewed',
              scrollable: true,
              rows: 1,
              productsPerRow: 6,
              showProductTitle: true,
              title: 'Recently Viewed',
            }}
            passedAppFunctions={this.props.passedAppFunctions}
            contentData={this.props.contentData}
          />
        </div>

        {this.props.contentData.dept != '0968' && (
          <ProductDetailReviews
            contentData={this.props.contentData}
            passedAppFunctions={this.props.passedAppFunctions}
            passedFunctions={this.props.passedFunctions}
          />
        )}
        <WcPowerPage {...this.props} />

        <ShowImboxModal passedFunctions={this.props.passedFunctions} />
      </section>
    );
  }
}

export default ProductDisplay;
